// extracted by mini-css-extract-plugin
export default {"scrollable":"ValidateResult_scrollable_YfSiX"};